module.exports = __webpack_public_path__ + "img/34.e2a0c6c3.png";